import { render } from "./FbnSigner.vue?vue&type=template&id=5392f4de"
import script from "./FbnSigner.vue?vue&type=script&lang=js"
export * from "./FbnSigner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__